const color = {
  primary: "#28AA4A",
  secondary: "#00ABF4",
  text: "#202020",
  lightText:"#878787",
  lightGray:"#F1F1F1",
  card:"#fff",
  lightGreen:"#28AA4A33",
  lightRed:"#E9303033",
  red:"Red"
}
export default color;